<template>
<!-- 车辆信息 -->
  <div class="equipment">
    <!-- 表格 -->
    <DiluTable :list="list" :tableConfig="tableConfig">
      <el-table-column
        prop="bindType"
        :label="$t('pages.equipment.text39')"
        width="180px"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.bindType == 0
              ? $t("pages.user.text13")
              : $t("pages.user.text14")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="bikeCategoryName"
        :label="$t('pages.user.text15')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="bikeTypeName"
        :label="$t('pages.user.text16')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="bikeTypeImgPath"
        :label="$t('pages.user.text17')"
        align="center"
      >
        <template slot-scope="scope">
          <el-image
            :src="scope.row.bikeTypeImgPath"
            class="elimg"
            style="width: 80px"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="bikeCode"
        :label="$t('pages.user.text18')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="rideMiles"
        :label="$t('pages.user.text27')"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.rideMiles }}km</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="rideTime"
        :label="$t('pages.user.text19')"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ ChangeHourMinutestr(scope.row.rideTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="bindTime"
        :label="$t('pages.user.text20')"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.bindTime }}Day</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="see(scope.row)" type="text">
            {{ $t("button.look") }}
            </el-button>
          </div>
        </template>
      </el-table-column>

    </DiluTable>
  </div>
</template>


<script>
import DiluTable from "../../../../components/pubilc/dilu-table.vue";
export default {
  data() {
    return {
      tableConfig: {
        isTree: false,
        isTreeText: "id",
        isPage: false,
      },
      list: [],
    };
  },
  watch: {
    activeName(newValue) {
      if (newValue == "second") {
        this.getBindBikeByUserId();
      }
    },
  },
  props: ["activeName", "currentUser"],
  components: {
    DiluTable,
  },
  methods: {
    getBindBikeByUserId() {
      let str = "?id=" + this.currentUser.id;
      this.request.getBindBikeByUserId(str).then((res) => {
        this.list = res.data;
      });
    },
    ChangeHourMinutestr(str) {
      if (str < 60) {
        return str + "min";
      }
      if (str >= 60) {
        return (str / 60).toFixed(2) + "h";
      }
    },
    //查看
    see(e) {
      this.$router.push({
        path: "/equipment/deviceManagement/equipmentInfo",
        query: {
          id: e.bikeId,
          bikeCode: e.bikeCode,
        },
      });
    },
  },
};
</script>


<style scoped>
.equipment {
  display: flex;
  flex-direction: column;
}
</style>